import { useNavigate } from 'react-router-dom';

import { RoutePath } from '@/routes/RoutePath';

import { SCREENER_ALL_FACILITIES_PARAM } from './useIsScreenerAllFacilitiesSelected';

const useNavigateToScreenerAllFacilities = (pathname: RoutePath) => {
  const navigate = useNavigate();

  const navigateToAllFacilitiesLeads = () => {
    const targetUrl = `${pathname}?${SCREENER_ALL_FACILITIES_PARAM}=true`;

    navigate(targetUrl);
  };

  return navigateToAllFacilitiesLeads;
};

export default useNavigateToScreenerAllFacilities;
